import React, {useState,useEffect} from 'react'
import { Box,Typography,Button, } from '@mui/material'
import clinicService from '../../../../../services/clinic.service'
import {useForm} from 'react-hook-form'
import {toast} from 'react-toastify'

function NewReputation({clinicid,checkReputationService}) {
    const [showForm,setShowForm] = useState(false)
    const { register, handleSubmit, setValue, formState:{errors} } = useForm();

    const onSubmit = (data)=>{
        const newData = {...data,clinicId:clinicid}
        clinicService.addReputationClinic(clinicid,newData)
        .then(res=>{
            toast.success("Reputation Enhancement Added",{
                position:toast.POSITION.BOTTOM_RIGHT
            })
            checkReputationService()
        })
        .catch(err=>{
            toast.error('Error, Please check Url',{
                position:toast.POSITION.BOTTOM_RIGHT
            })
        })
    }
  return (
   <>

         <Box p={3} border="1px dashed #ccc" borderRadius={3} textAlign="center">
            {showForm ? <>
                <form onSubmit = {handleSubmit(onSubmit)} className='row row-cols-lg-auto g-3 align-items-center'>
                   
                        <div className="col-12">
                            <label htmlFor="" className="form-label">Enter ShortCode :</label>
                        </div>
                       <div className="col-12">
                            <input 
                                type="text" 
                                className="form-control"
                                {...register("shortCode")}
                                />
                           
                       </div>
                       <div className="col-12">
                            <button className="btn btn-sm btn-primary" type="submit">Submit</button>
                       </div>
                </form>
                <p className="h6 mt-4">Note: Short Code is used in url.</p>
            </>:<>
            <Typography variant='disabled'>
                This clinic doesnot have Reputation Enhancements setup done. Click to create a shortCode to get started. 
            </Typography>
            <Button variant='outlined' sx={{m:3}} onClick={()=>setShowForm(!showForm)}>Setup Reputation Enhancement</Button>
            </>}
         </Box>
   </>
  )
}

export default NewReputation